module.exports = __webpack_public_path__ + "static/media/3.afb35120.png";